import { type GraphPath, IPF_NO_VALUE_CLOUD } from '@ipfabric/utils';
import type { ReactNode } from 'react';

export const getPathNameLabelStyle =
  (path: GraphPath) =>
  (label: string): ReactNode =>
    path === IPF_NO_VALUE_CLOUD ? <em>{label}</em> : label;
